<template>
    <div>
        <a :href="link"
           class="block text-center p-16"
           target="_blank"
        >
            <svg-icon :type="icon" class="!w-164 !h-164 mx-auto" />

            <span class="block my-24 text-body font-semibold text-primary break-words first-letter:uppercase">
                {{ title }}
            </span>

            <simple-button
                class="mx-auto"
                display="secondary"
                look="primary"
                v-if="link"
            >
                {{ $t('general.view') }}
            </simple-button>
        </a>
    </div>
</template>

<script>
import SvgIcon from '../ui/SvgIcon';
import SimpleButton from '../ui/SimpleButton';

export default {
    components: {SimpleButton, SvgIcon},
    props: {
        icon: String,
        title: String,
        link: String,
    },
};
</script>